import { createTheme } from '@material-ui/core/styles';

export default createTheme({
  // direction: 'rtl',
  palette: {
    primary: {
      main: '#052971',
      light: '#218683',
    },
    secondary: {
      main: '#b7a493',
    },
    error: {
      main: '#f44336',
    },
  },
  typography: {
    fontFamily: [
      'Shabnam',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
    ].join(','),
  },
  overrides: {
    MuiButton: {
      contained: {
        border: '1px solid #052971',
        backgroundColor: '#052971',
        '&:hover': {
          backgroundColor: '#fff',
          color: '#052971',
        },
      },
      containedPrimary: {
        border: '1px solid #b7a493',
        backgroundColor: '#b7a493',
        '&:hover': {
          backgroundColor: '#fff',
          color: '#b7a493',
        },
      },
      outlined: {
        borderColor: '#052971',
        color: '#052971',
      },
      outlinedSecondary: {
        borderColor: '#b7a493',
        color: '#b7a493',
      },
      startIcon: {
        marginLeft: 8,
        marginRight: -4,
      },
      endIcon: {
        marginLeft: -4,
        marginRight: 8,
      },
    },
    MuiBadge: {
      badge: {
        color: '#fff',
        backgroundColor: '#53b9b6',
      },
      dot: {
        height: 12,
        minWidth: 12,
        borderRadius: '50%',
      },
    },
  },
});
